/* This is the emis community components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 63px" width="800" border="1px;" cellspacing="0px;">
        <tbody>
          <tr style="height: 25px">
            <td
              style="
                width: 270px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              បរិយាយតម្រូវការ
            </td>
            <td
              style="
                width: 129px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              អត្ថិភាព
            </td>
            <td
              style="
                width: 130px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ចំនួនសមាជិក
            </td>
            <td
              style="
                width: 240px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              សរុប
            </td>
          </tr>
          <tr style="height: 31px">
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
          </tr>
          <tr v-for="(value, row) in 5" :key="row" style="height: 25px">
            <td
              style="
                width: 130px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ comText[row] }}
            </td>
            <td>
              <v-select
                class="py-0 px-1"
                v-model="data[row].dt[0]"
                hide-details
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                @keypress.native="onSelect($event, row)"
              >
              </v-select>
            </td>
            <td class="td-row-data">
              <numberinput v-model="data[row].dt[1]" class="number" />
            </td>
            <td class="td-row-data">
              <numberinput v-model="data[row].dt[2]" class="number" />
            </td>
            <td class="td-row-data-text">
              {{ comDesc[row] }}
              <numberinput v-model="data[row].dt[3]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- second part of page 6 -->
      <br />
      <table style="height: 25px" width="800" border="1px;" cellspacing="0px;">
        <tbody>
          <tr style="height: 10px">
            <td
              style="
                width: 270px;
                height: 20px;
                text-align: center;
                vertical-align: middle;
              "
            >
              បរិយាយ
            </td>
            <td
              style="
                width: 129px;
                height: 20px;
                text-align: center;
                vertical-align: middle;
              "
            >
              អត្ថិភាព
            </td>
          </tr>
          <tr v-for="(value, row) in 4" :key="row" style="height: 20px">
            <td
              style="
                width: 130px;
                height: 20px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ plaText[row] }}
            </td>
            <td>
              <v-select
                class="py-0 px-1"
                v-model="data[row + 5].dt[0]"
                hide-details
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                @keypress.native="onSelect($event, row + 5)"
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import {
  comText,
  comDesc,
  plaText,
  yesNo6,
} from "@/utils/ascf/commonConfig.js";

export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      comText: comText,
      comDesc: comDesc,
      plaText: plaText,
      yesNo6: yesNo6,
    };
  },
  methods: {
    onSelect: function (event, ind) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[ind].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.td-row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.td-row-data-text {
  width: 130px;
  height: 25px;
  text-align: right;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 13px;
}
</style>